import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';
import {AxisY} from '../utils/math.js';

const tempVec3 = vec3.create();

export const allPowerFruit: Partial<{[key in FruitTypes]: FruitData}> = {};

export enum FruitTypes {
    Fire = 1,
    Dark,
    Rock,
    Electric,
    Sand,
}

const damageDistribution = 0.35; // 35% of damage random
/**
 * The damage calculation for each fruit type.
 * The stat is the current PowerFruit stat of the player.
 */
export const FruitDamage: {[key in FruitTypes]: (stat: number) => number} = {
    [FruitTypes.Fire]: (stat = 0) =>
        Math.ceil(
            ((10 * stat) / 20) *
                (1 + Math.random() * damageDistribution * 2 - damageDistribution)
        ),
    [FruitTypes.Dark]: (stat = 0) =>
        Math.ceil(
            ((10 * stat) / 20) *
                (1 + Math.random() * damageDistribution * 2 - damageDistribution)
        ),
    [FruitTypes.Rock]: (stat = 0) =>
        Math.ceil(
            ((10 * stat) / 20) *
                (1 + Math.random() * damageDistribution * 2 - damageDistribution)
        ),

    /* This is handled by a power sequence
     * It is called multiple times during 1 attack
     */
    [FruitTypes.Electric]: (stat = 0) =>
        Math.ceil(
            ((10 * stat) / 20) *
                (1 + Math.random() * damageDistribution * 2 - damageDistribution)
        ),

    [FruitTypes.Sand]: (stat = 0) =>
        Math.ceil(
            (stat / 40) * (1 + Math.random() * damageDistribution * 2 - damageDistribution)
        ),
};

export class FruitData {
    power: number;
    color: number[];
    fruitType: FruitTypes;
    energyUsage: number;
    distance: number;
    damageCalculation: (stat: number) => number;

    constructor(
        power: number,
        color: number[],
        fruitType: FruitTypes,
        energyUsage: number,
        distance: number = 2
    ) {
        this.power = power;
        this.color = color;
        this.fruitType = fruitType;
        this.energyUsage = energyUsage;
        this.damageCalculation = FruitDamage[fruitType];
        this.distance = distance;
    }
}

export class PowerFruit extends Component {
    static TypeName = 'power-fruit';

    @property.enum(['', 'Fire', 'Dark', 'Rock', 'Electric', 'Sand'], 'Fire')
    fruitType: FruitTypes = FruitTypes.Fire;

    @property.color(1, 1, 1, 1)
    color = [1, 1, 1, 1];

    @property.float(1)
    energyUsage = 1;

    @property.float(2)
    distance = 2;

    time = 0;

    fruitData: FruitData | null = null;

    start(): void {
        this.fruitData = new FruitData(
            0,
            this.color,
            this.fruitType,
            this.energyUsage,
            this.distance
        );
        allPowerFruit[this.fruitType] = this.fruitData;
    }

    update(dt: number) {
        this.time += dt;

        tempVec3[0] = 0;
        tempVec3[1] = Math.sin(this.time) * 0.5;
        tempVec3[2] = 0;

        const meshObject = this.object.children[0];
        meshObject.setPositionLocal(tempVec3);
        meshObject.rotateAxisAngleDegLocal(AxisY, dt * 45);
    }
}
